module.exports = "/static/assets/e1aa217ece74e4dd29657f9f91a69f6e.svg";